import axios from "axios";
import {
  formatValidationErrors,
  getFromStorage,
  renderToastMsg,
  // setToStorage,
} from "src/utils/functions";

const requestUrl = () => {
  var url = window.origin;
  if (url?.includes("http://localhost")) {
    return process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_LOCAL_BASEURL}`
      : `${process.env.REACT_APP_PROD_BASEURL}`;
  } else {
    return process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_LOCAL_BASEURL_LIVE}`
      : `${process.env.REACT_APP_PROD_BASEURL_LIVE}`;
  }
};

const authApi = axios.create({
  baseURL: requestUrl(),
  headers: {
    "Content-Type": "application/json",
    // "Access-Control-Allow-Credentials": true,
  },
});

authApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response.status === 401) {
      renderToastMsg(error.response.data.msg).then(() => {
        localStorage.clear();
      });
    } else if (error.response.status === 503) {
      renderToastMsg(error.response.data.msg, "success");
    } else {
      renderToastMsg(formatValidationErrors(error.response.data.msg), "error");
      throw new Error(error.response.data.msg, {
        cause: error.response.status,
      });
    }
  }
);

//* Sign in
export const signin = (data) => {
  return authApi.post("/staffs.php?action=login", data);
};

//* Submit Inquires
export const submitInquires = (data) => {
  return authApi.post("/users.php?action=submit_form", data);
};

//* Forgot Password
export const forgotPassword = (data) => {
  return authApi.post("/auth/forgotPassword", data);
};

const api = axios.create({
  baseURL: requestUrl(),
  headers: {
    "Content-Type": "application/json",
    // "Access-Control-Allow-Credentials": true,
  },
});

api.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${getFromStorage("token")}`;
  return config;
}, null);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response.status === 401) {
      renderToastMsg(error.response.data.msg).then(() => {
        localStorage.clear();
        window.location.reload();
      });
    } else if (error.response.status === 503) {
      renderToastMsg(error.response.data.msg, "success");
    } else {
      renderToastMsg(error.response.data.msg);
      throw new Error(error.response.data.msg, {
        cause: error.response.status,
      });
    }
  }
);

//? Inventory
//* Get All Inventory
export const getAllInventory = (data) => {
  return api.get("/inventory.php", {
    params: {
      action: "get_inventory",
      ...data,
    },
  });
};
export const getAllInventories = (data) => {
  return api.get("/inventory.php", {
    params: {
      action: "get_inventories",
      ...data,
    },
  });
};

//* Create  inventory
export const createInventory = (data) => {
  return api.post("/inventory.php?action=add_inventory", data);
};
//* update inventory
export const deleteInventory = (data) => {
  return api.post("/inventory.php?action=delete_inventory", data);
};

//* Delete inventory
export const updateInventory = (data) => {
  return api.post("/inventory.php?action=update_inventory", data);
};

//* Get all appliances
export const getAllAppliances = (data) => {
  return api.get("/index.php", {
    params: {
      action: "get_appliances",
      ...data,
    },
  });
};

//* Create  appliance
export const createAppliance = (data) => {
  return api.post("/index.php?action=add_appliance", data);
};
//* update appliance
export const updateAppliance = (data) => {
  return api.post("/index.php?action=update_appliance", data);
};
//* delete appliance
export const deleteAppliance = (data) => {
  return api.post("/index.php?action=delete_appliance", data);
};

//* get all customer
export const getAllCustomers = (data) => {
  return api.get("/users.php", {
    params: {
      action: "get_users",
      ...data,
    },
  });
};
//* get one customer
export const getOneCustomers = (id) => {

  return api.get("/users.php", {
    params: { action: "get_user", id },
  });
};

//* get all admin profile
export const getAllAdmin = () => {
  return api.post("/staffs.php?action=get_staffs");
};

//* update admin status
export const updateAdminStatus = (data) => {
  return api.post("/staffs.php?action=update_status", data);
};

//*create  admin profile
export const createProfile = (data) => {
  return api.post("/staffs.php?action=add_staff", data);
};

//*update profile password
export const updateProfilePassword = (data) => {
  return api.post("/staffs.php?action=update_password", data);
};

//*update admin password update
export const adminPasswordUpdate = (data) => {
  return api.post("/staffs.php?action=admin_update_password", data);
};

//*Locations
//Get Locations
export const getAllLocations = () => {
  return api.get("/locations.php?action=get_locations");
};

// add location
export const addLocation = (data) => {
  return api.post("/locations.php?action=add_location", data);
};
// update location
export const updateLocation = (data) => {
  return api.post("/locations.php?action=update_location", data);
};

//Get Orders

export const getAllOrders = (data) => {
  return api.get("/orders.php", {
    params: {
      action: "get_order",
      ...data,
    },
  });
};

// Create Order
export const createOrder = (data) => {
  return api.post("/orders.php?action=add_order", data);
};

//Brands
//Get Brands
export const getAllBrands = () => {
  return api.get("/brands.php?action=get_brands");
};

// add brand
export const addBrand = (data) => {
  return api.post("/brands.php?action=add_brand", data);
};
// update brand
export const updateBrand = (data) => {
  return api.post("/brands.php?action=update_brand", data);
};

// update brand
export const logOut = () => {
  return api.post("/staffs.php?action=logout");
};
